import { render, staticRenderFns } from "./Home.v1.vue?vue&type=template&id=499132cc&scoped=true&"
import script from "./Home.v1.vue?vue&type=script&lang=js&"
export * from "./Home.v1.vue?vue&type=script&lang=js&"
import style0 from "./Home.v1.vue?vue&type=style&index=0&id=499132cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499132cc",
  null
  
)

export default component.exports